<template>
  <b-modal
    ref="otpModal"
    title="Código de verificación"
    hide-footer
    no-close-on-backdrop
    centered
  >
    <div class="text-center mb-4">
      <p>Se ha enviado un código de verificación a su correo electrónico.</p>
      <p class="text-muted">Ingrese el código para completar la firma.</p>
    </div>
    <b-overlay :show="loading">
      <div class="row justify-content-center">
        <div class="col-12">
          <otp-input
            v-model="otpCode"
            :disabled="loading"
            @complete="submitOtp"
          />
        </div>
      </div>
      <div class="text-center mt-4">
        <b-button
          variant="success"
          @click="submitOtp"
          :disabled="otpCode.length < 6 || loading"
        >
          Confirmar firma
        </b-button>
        <b-button
          variant="outline-secondary"
          class="ml-2"
          @click="cancel"
          :disabled="loading"
        >
          Cancelar
        </b-button>
      </div>
    </b-overlay>
  </b-modal>
</template>
<script>
import OtpInput from '@/components/inputs/OtpInput';

export default {
  name: 'OtpModalExternal',
  components: { OtpInput },
  data() {
    return {
      otpCode: '',
      loading: false,
      submitted: false,
    };
  },
  methods: {
    show() {
      this.otpCode = '';
      this.submitted = false;
      this.$refs.otpModal.show();
    },
    hide() {
      this.$refs.otpModal.hide();
    },
    submitOtp() {
      if (!this.otpCode || this.otpCode.length < 6 || this.submitted) return;
      this.submitted = true;
      this.$emit('submit', this.otpCode);
    },
    cancel() {
      this.otpCode = '';
      this.hide();
      this.$emit('cancel');
    },
    setLoading(value) {
      this.loading = value;
      if (!value) {
        this.submitted = false;
      }
    }
  }
}
</script>
